/* Common */

/* PANEL */
export const PANEL_LEFT_SHOW_HIDE_CLICK = "PANEL_LEFT_SHOW_HIDE_CLICK";
export const PANEL_RIGHT_RECORD_DETAILS_SHOW_HIDE_CLICK = "PANEL_RIGHT_RECORD_DETAILS_SHOW_HIDE_CLICK";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const AUTO_LOGIN = "AUTO_LOGIN";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_ERROR = "GET_USER_INFO_ERROR";

/* Menuitem List*/
export const GET_COLLECTION_RECORDS = "GET_COLLECTION_RECORDS";
export const GET_COLLECTION_RECORDS_SUCCESS = "GET_COLLECTION_RECORDS_SUCCESS";
export const GET_COLLECTION_RECORDS_ERROR = "GET_COLLECTION_RECORDS_ERROR";
export const GET_CART_LINKS = "GET_CART_LINKS";
export const GET_CART_LINKS_SUCCESS = "GET_CART_LINKS_SUCCESS";
export const GET_CART_LINKS_ERROR = "GET_CART_LINKS_ERROR";

/* RECORD_LISTING */
export const GET_DROPDOWN_SEARCH_LIST = "GET_DROPDOWN_SEARCH_LIST";
export const GET_DROPDOWN_SEARCH_LIST_SUCCESS = "GET_DROPDOWN_SEARCH_LIST_SUCCESS";
export const GET_RECORDS = "GET_RECORDS";
export const GET_RECORDS_SUCCESS = "GET_RECORDS_SUCCESS";
export const GET_RECORDS_ERROR = "GET_RECORDS_ERROR";
export const UPDATE_SELECTED_RECORDS = "UPDATE_SELECTED_RECORDS";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const UPDATE_RECORD_LISTING_STATE = "UPDATE_RECORD_LISTING_STATE";
export const GET_CHILD_RECORDS = "GET_CHILD_RECORDS";
export const GET_CHILD_RECORDS_SUCCESS = "GET_CHILD_RECORDS_SUCCESS";
export const GET_CHILD_RECORDS_ERROR = "GET_CHILD_RECORDS_ERROR";

export const GET_ACCOUNT_RECORDS = "GET_ACCOUNT_RECORDS";
export const GET_ACCOUNT_RECORDS_SUCCESS = "GET_ACCOUNT_RECORDS_SUCCESS";
export const GET_ACCOUNT_RECORDS_ERROR = "GET_ACCOUNT_RECORDS_ERROR";

export const GET_GA_RECORDS = "GET_GA_RECORDS";
export const GET_GA_RECORDS_SUCCESS = "GET_GA_RECORDS_SUCCESS";
export const GET_GA_RECORDS_ERROR = "GET_GA_RECORDS_ERROR";

export const GET_NEWS_ITEM = "GET_NEWS_ITEM";
export const GET_NEWS_ITEM_SUCCESS = "GET_NEWS_ITEM_SUCCESS";
export const GET_NEWS_ITEM_ERROR = "GET_NEWS_ITEM_ERROR";

/*Payment Profile*/
export const GET_PAYMENT_PROFILE = "GET_PAYMENT_PROFILE";
export const GET_PAYMENT_PROFILE_SUCCESS = "GET_PAYMENT_PROFILE_SUCCESS";
export const GET_PAYMENT_PROFILE_ERROR = "GET_PAYMENT_PROFILE_ERROR";
export const GET_PAYMENT_PROFILE_LIST = "GET_PAYMENT_PROFILE_LIST";
export const GET_PAYMENT_PROFILE_LIST_SUCCESS = "GET_PAYMENT_PROFILE_LIST_SUCCESS";
export const GET_PAYMENT_PROFILE_LIST_ERROR = "GET_PAYMENT_PROFILE_LIST_ERROR";
export const SAVE_PAYMENT_PROFILE = "SAVE_PAYMENT_PROFILE";
export const SAVE_PAYMENT_PROFILE_SUCCESS = "SAVE_PAYMENT_PROFILE_SUCCESS";
export const SAVE_PAYMENT_PROFILE_ERROR = "SAVE_PAYMENT_PROFILE_ERROR";
export const GET_MONERIS_CHECKOUT_REQUEST_DATA = "GET_MONERIS_CHECKOUT_REQUEST_DATA";
export const GET_MONERIS_CHECKOUT_REQUEST_DATA_SUCCESS = "GET_MONERIS_CHECKOUT_REQUEST_DATA_SUCCESS";
export const GET_MONERIS_CHECKOUT_REQUEST_DATA_ERROR = "GET_MONERIS_CHECKOUT_REQUEST_DATA_ERROR";
export const GET_MONERIS_CHECKOUT_RECEIPT = "GET_MONERIS_CHECKOUT_RECEIPT";
export const GET_MONERIS_CHECKOUT_RECEIPT_SUCCESS = "GET_MONERIS_CHECKOUT_RECEIPT_SUCCESS";
export const GET_MONERIS_CHECKOUT_RECEIPT_ERROR = "GET_MONERIS_CHECKOUT_RECEIPT_ERROR";
export const PAY_USING_CREDIT_CARD = "PAY_USING_CREDIT_CARD";
export const PAY_USING_CREDIT_CARD_SUCCESS = "PAY_USING_CREDIT_CARD_SUCCESS";
export const PAY_USING_CREDIT_CARD_ERROR = "PAY_USING_CREDIT_CARD_ERROR";
export const GET_MONERIS_CHECKOUT_PAYMENT_METHODS = "GET_MONERIS_CHECKOUT_PAYMENT_METHODS";
export const GET_MONERIS_CHECKOUT_PAYMENT_METHODS_SUCCESS = "GET_MONERIS_CHECKOUT_PAYMENT_METHODS_SUCCESS";
export const GET_MONERIS_CHECKOUT_PAYMENT_METHODS_ERROR = "GET_MONERIS_CHECKOUT_PAYMENT_METHODS_ERROR";
export const RECORD_PAYMENT = "RECORD_PAYMENT";
export const RECORD_PAYMENT_SUCCESS = "RECORD_PAYMENT_SUCCESS";
export const RECORD_PAYMENT_ERROR = "RECORD_PAYMENT_ERROR";
export const TRASH_PAYMENT_PROFILE = "TRASH_PAYMENT_PROFILE";
export const TRASH_PAYMENT_PROFILE_SUCCESS = "TRASH_PAYMENT_PROFILE_SUCCESS";
export const TRASH_PAYMENT_PROFILE_ERROR = "TRASH_PAYMENT_PROFILE_ERROR";

export const UPDATE_PAYMENT_METHOD_SELECT_STATE = "UPDATE_PAYMENT_METHOD_SELECT_STATE";

/*Payment Method*/

export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD";
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS";
export const GET_PAYMENT_METHOD_ERROR = "GET_PAYMENT_METHOD_ERROR";
export const GET_PAYMENT_METHOD_CREATED_BY = "GET_PAYMENT_METHOD_CREATED_BY";
export const GET_PAYMENT_METHOD_CREATED_BY_SUCCESS = "GET_PAYMENT_METHOD_CREATED_BY_SUCCESS";
export const GET_PAYMENT_METHOD_CREATED_BY_ERROR = "GET_PAYMENT_METHOD_CREATED_BY_ERROR";

/*WEB_BUILDER*/
export const GET_WEB_BUILDER_DATA = "GET_WEB_BUILDER_DATA";
export const GET_WEB_BUILDER_DATA_SUCCESS = "GET_WEB_BUILDER_DATA_SUCCESS";
export const GET_WEB_BUILDER_DATA_ERROR = "GET_WEB_BUILDER_DATA_ERROR";
export const UPDATE_WEB_BUILDER_STATE = "UPDATE_WEB_BUILDER_STATE";
export const SAVE_DESIGNER_DATA = "SAVE_DESIGNER_DATA";

export const SAVE_DESIGNER_SUCCESS = "SAVE_DESIGNER_SUCCESS";
export const SAVE_DESIGNER_ERROR = "SAVE_DESIGNER_ERROR";
export const HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION = "HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION";
export const HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_SUCCESS = "HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_SUCCESS";
export const HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_ERROR = "HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_ERROR";

/*Catalog listing*/
export const GET_CATALOG_RECORDS = "GET_CATALOG_RECORDS";
export const GET_CATALOG_SUCCESS = "GET_CATALOG_SUCCESS";
export const GET_CATALOG_ERROR = "GET_CATALOG_ERROR";

export const GET_CATALOG_SINGLE_RECORD = "GET_CATALOG_SINGLE_RECORD";
export const GET_CATALOG_SINGLE_SUCCESS = "GET_CATALOG_SINGLE_SUCCESS";
export const GET_CATALOG_SINGLE_ERROR = "GET_CATALOG_SINGLE_ERROR";

/*CONTACT_BLOCK*/
export const GET_CONTACTBLOCK_LIST = "GET_CONTACTBLOCK_LIST";
export const GET_CONTACTBLOCK_LIST_SUCCESS = "GET_CONTACTBLOCK_LIST_SUCCESS";
export const GET_CONTACTBLOCK_LIST_ERROR = "GET_CONTACTBLOCK_LIST_ERROR";

export const UPDATE_CONTACTBLOCK = "UPDATE_CONTACTBLOCK";
export const UPDATE_CONTACTBLOCK_SUCCESS = "UPDATE_CONTACTBLOCK_SUCCESS";
export const UPDATE_CONTACTBLOCK_ERROR = "UPDATE_CONTACTBLOCK_ERROR";

export const UPDATE_ORDER_CONTACTBLOCK = "UPDATE_ORDER_CONTACTBLOCK";
export const UPDATE_ORDER_CONTACTBLOCK_SUCCESS = "UPDATE_ORDER_CONTACTBLOCK_SUCCESS";
export const UPDATE_ORDER_CONTACTBLOCK_ERROR = "UPDATE_ORDER_CONTACTBLOCK_ERROR";

export const GET_CONTACTBLOCK = "GET_CONTACTBLOCK";
export const GET_CONTACTBLOCK_SUCCESS = "GET_CONTACTBLOCK_SUCCESS";
export const GET_CONTACTBLOCK_ERROR = "GET_CONTACTBLOCK_ERROR";

export const GET_ORDER_CONTACTBLOCK = "GET_ORDER_CONTACTBLOCK";
export const GET_ORDER_CONTACTBLOCK_SUCCESS = "GET_ORDER_CONTACTBLOCK_SUCCESS";
export const GET_ORDER_CONTACTBLOCK_ERROR = "GET_ORDER_CONTACTBLOCK_ERROR";

export const CREATE_CONTACTBLOCK = "CREATE_CONTACTBLOCK";
export const CREATE_CONTACTBLOCK_SUCCESS = "CREATE_CONTACTBLOCK_SUCCESS";
export const CREATE_CONTACTBLOCK_ERROR = "CREATE_CONTACTBLOCK_SUCCESS";

export const SAVE_CONTACTBLOCK = "SAVE_CONTACTBLOCK";
export const SAVE_CONTACTBLOCK_SUCCESS = "SAVE_CONTACTBLOCK_SUCCESS";
export const SAVE_CONTACTBLOCK_ERROR = "SAVE_CONTACTBLOCK_ERROR";

export const DELETE_CONTACTBLOCK = "DELETE_CONTACTBLOCK";
export const DELETE_CONTACTBLOCK_SUCCESS = "DELETE_CONTACTBLOCK_SUCCESS";
export const DELETE_CONTACTBLOCK_ERROR = "DELETE_CONTACTBLOCK_SUCCESS";

/*ADDRESS_LIST*/
export const GET_ADDRESS_LIST = "GET_ADDRESS_LIST";
export const GET_ADDRESS_LIST_SUCCESS = "GET_ADDRESS_LIST_SUCCESS";
export const GET_ADDRESS_LIST_ERROR = "GET_ADDRESS_LIST_ERROR";

export const TOGGLE_CART_RECORDS = "TOGGLE_CART_RECORDS";
export const TOGGLE_CART_RECORD_SUCCESS = "TOGGLE_CART_RECORD_SUCCESS";
export const TOGGLE_CART_RECORD_ERROR = "TOGGLE_CART_RECORD_ERROR";
export const TOGGLE_REMOVE_CART_RECORDS = "TOGGLE_REMOVE_CART_RECORDS";
export const SHOW_CART_RECORDS = "SHOW_CART_RECORDS";
export const SHOW_CART_PROGRESS_RECORDS = "SHOW_CART_PROGRESS_RECORDS";

/*Line items listing*/
export const GET_LINEITEMS_RECORDS = "GET_LINEITEMS_RECORDS";
export const GET_LINEITEMS_SUCCESS = "GET_LINEITEMS_SUCCESS";
export const GET_LINEITEMS_ERROR = "GET_LINEITEMS_ERROR";

export const UPDATE_LINEITEM_RECORD = "UPDATE_LINEITEM_RECORD";
export const UPDATE_LINEITEM_SUCCESS = "UPDATE_LINEITEM_SUCCESS";
export const UPDATE_LINEITEM_ERROR = "UPDATE_LINEITEM_ERROR";

export const DELETE_LINEITEM_RECORD = "DELETE_LINEITEM_RECORD";
export const DELETE_LINEITEM_SUCCESS = "DELETE_LINEITEM_SUCCESS";
export const DELETE_LINEITEM_ERROR = "DELETE_LINEITEM_ERROR";
export const UPDATE_LINE_ITEMS_STATE = "UPDATE_LINE_ITEMS_STATE";

/*Term listing*/
export const GET_TERM_RECORDS = "GET_TERM_RECORDS";
export const GET_TERM_RECORDS_SUCCESS = "GET_TERM_RECORDS_SUCCESS";
export const GET_TERM_RECORDS_ERROR = "GET_TERM_RECORDS_ERROR";
export const UPDATE_TERM_RECORDS = "UPDATE_TERM_RECORDS";
export const REFRESH_TERM_RECORDS = "REFRESH_TERM_RECORDS";
export const UPDATE_SEARCH_RECORDS = "UPDATE_SEARCH_RECORDS";

/* INVOICE */
export const GET_INVOICE = "GET_INVOICE";
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_ERROR = "GET_INVOICE_ERROR"

export const GET_INVOICE_LINEITEMS = "GET_INVOICE_LINEITEMS";
export const GET_INVOICE_LINEITEMS_SUCCESS = "GET_INVOICE_LINEITEMS_SUCCESS";
export const GET_INVOICE_LINEITEMS_ERROR = "GET_INVOICE_LINEITEMS_ERROR";

export const GET_INVOICE_BILLINGCONTACT = "GET_INVOICE_BILLINGCONTACT";
export const GET_INVOICE_BILLINGCONTACT_SUCCESS = "GET_INVOICE_BILLINGCONTACT_SUCCESS";
export const GET_INVOICE_BILLINGCONTACT_ERROR = "GET_INVOICE_BILLINGCONTACT_ERROR";

/* NEW_RECORD */
export const CREATE_NEW_RECORD = "CREATE_NEW_RECORD";
export const CREATE_NEW_RECORD_SUCCESS = "CREATE_NEW_RECORD_SUCCESS";
export const CREATE_NEW_RECORD_ERROR = "CREATE_NEW_RECORD_ERROR";

/* NEW_POST RECORD */
export const CREATE_TASKS_NEW_RECORD = "CREATE_TASKS_NEW_RECORD";
export const CREATE_TASKS_NEW_RECORD_SUCCESS = "CREATE_TASKS_NEW_RECORD_SUCCESS";
export const CREATE_TASKS_NEW_RECORD_ERROR = "CREATE_TASKS_NEW_RECORD_ERROR";

/* NEW_NODE EDGE RECORD */

export const GET_NODE_EDGE = "GET_NODE_EDGE";
export const GET_NODE_EDGE_SUCCESS = "GET_NODE_EDGE_SUCCESS";
export const GET_NODE_EDGE_ERROR = "GET_NODE_EDGE_ERROR";

export const UPDATE_NODE_EDGE = "UPDATE_NODE_EDGE";
export const UPDATE_NODE_EDGE_SUCCESS = "UPDATE_NODE_EDGE_SUCCESS";
export const UPDATE_NODE_EDGE_ERROR = "UPDATE_NODE_EDGE_ERROR";

/* NEW_SETTINGS RECORD */
export const CREATE_SETTINGS_NEW_RECORD = "CREATE_SETTINGS_NEW_RECORD";
export const CREATE_SETTINGS_NEW_RECORD_SUCCESS = "CREATE_SETTINGS_NEW_RECORD_SUCCESS";
export const CREATE_SETTINGS_NEW_RECORD_ERROR = "CREATE_SETTINGS_NEW_RECORD_ERROR";

export const GET_SETTINGS_NEW_RECORD = "GET_SETTINGS_NEW_RECORD";
export const GET_SETTINGS_NEW_RECORD_SUCCESS = "GET_SETTINGS_NEW_RECORD_SUCCESS";
export const GET_SETTINGS_NEW_RECORD_ERROR = "GET_SETTINGS_NEW_RECORD_ERROR";

export const CREATE_CATALOGITEM_NEW_RECORD = "CREATE_CATALOGITEM_NEW_RECORD";
export const CREATE_CATALOGITEM_NEW_RECORD_SUCCESS = "CREATE_CATALOGITEM_NEW_RECORD_SUCCESS";
export const CREATE_CATALOGITEM_NEW_RECORD_ERROR = "CREATE_CATALOGITEM_NEW_RECORD_ERROR";

export const GET_CATALOGITEM_NEW_RECORD = "GET_CATALOGITEM_NEW_RECORD";
export const GET_CATALOGITEM_NEW_RECORD_SUCCESS = "GET_CATALOGITEM_NEW_RECORD_SUCCESS";
export const GET_CATALOGITEM_NEW_RECORD_ERROR = "GET_CATALOGITEM_NEW_RECORD_ERROR";

export const CREATE_CONTACTBLOCK_NEW_RECORD = "CREATE_CONTACTBLOCK_NEW_RECORD";
export const CREATE_CONTACTBLOCK_NEW_RECORD_SUCCESS = "CREATE_CONTACTBLOCK_NEW_RECORD_SUCCESS";
export const CREATE_CONTACTBLOCK_NEW_RECORD_ERROR = "CREATE_CONTACTBLOCK_NEW_RECORD_ERROR";

export const GET_CONTACTBLOCK_NEW_RECORD = "GET_CONTACTBLOCK_NEW_RECORD";
export const GET_CONTACTBLOCK_NEW_RECORD_SUCCESS = "GET_CONTACTBLOCK_NEW_RECORD_SUCCESS";
export const GET_CONTACTBLOCK_NEW_RECORD_ERROR = "GET_CONTACTBLOCK_NEW_RECORD_ERROR";

export const GET_CONTACTBLOCK_BYID_NEW_RECORD = "GET_CONTACTBLOCK_BYID_NEW_RECORD";
export const GET_CONTACTBLOCK_BYID_NEW_RECORD_SUCCESS = "GET_CONTACTBLOCK_BYID_NEW_RECORD_SUCCESS";
export const GET_CONTACTBLOCK_BYID_NEW_RECORD_ERROR = "GET_CONTACTBLOCK_BYID_NEW_RECORD_ERROR";

export const CREATE_ACCOUNTITEM_NEW_RECORD = "CREATE_ACCOUNTITEM_NEW_RECORD";
export const CREATE_ACCOUNTITEM_NEW_RECORD_SUCCESS = "CREATE_ACCOUNTITEM_NEW_RECORD_SUCCESS";
export const CREATE_ACCOUNTITEM_NEW_RECORD_ERROR = "CREATE_ACCOUNTITEM_NEW_RECORD_ERROR";

export const GET_ACCOUNTITEM_NEW_RECORD = "GET_ACCOUNTITEM_NEW_RECORD";
export const GET_ACCOUNTITEM_NEW_RECORD_SUCCESS = "GET_ACCOUNTITEM_NEW_RECORD_SUCCESS";
export const GET_ACCOUNTITEM_NEW_RECORD_ERROR = "GET_ACCOUNTITEM_NEW_RECORD_ERROR";

export const CREATE_ORDER_NEW_RECORD = "CREATE_ORDER_NEW_RECORD";
export const CREATE_ORDER_NEW_RECORD_SUCCESS = "CREATE_ORDER_NEW_RECORD_SUCCESS";
export const CREATE_ORDER_NEW_RECORD_ERROR = "CREATE_ORDER_NEW_RECORD_ERROR";

export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_ERROR = "UPDATE_ORDER_ERROR";

export const GET_ORDER_NEW_RECORD = "GET_ORDER_NEW_RECORD";
export const GET_ORDER_NEW_RECORD_SUCCESS = "GET_ORDER_NEW_RECORD_SUCCESS";
export const GET_ORDER_NEW_RECORD_ERROR = "GET_ORDER_NEW_RECORD_ERROR";

/*Order Confirmation*/
export const GET_ORDER_SUMMARY = "GET_ORDER_SUMMARY";
export const GET_ORDER_SUMMARY_SUCCESS = "GET_ORDER_SUMMARY_SUCCESS";
export const GET_ORDER_SUMMARY_ERROR = "GET_ORDER_SUMMARY_ERROR";

export const GET_ORDER_SUMMARY_CONFIRMATION = "GET_ORDER_SUMMARY_CONFIRMATION";
export const GET_ORDER_SUMMARY_CONFIRMATION_SUCCESS = "GET_ORDER_SUMMARY_CONFIRMATION_SUCCESS";
export const GET_ORDER_SUMMARY_CONFIRMATION_ERROR = "GET_ORDER_SUMMARY_CONFIRMATION_ERROR";

export const COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT = "COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT";
export const COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_SUCCESS = "COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_SUCCESS";
export const COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_ERROR = "COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_ERROR";

export const GET_ORDER_LINEITEMS = "GET_ORDER_LINEITEMS";
export const GET_ORDER_LINEITEMS_SUCCESS = "GET_ORDER_LINEITEMS_SUCCESS";
export const GET_ORDER_LINEITEMS_ERROR = "GET_ORDER_LINEITEMS_ERROR";

export const CREATE_PAYMENTMETHOD_NEW_RECORD = "CREATE_PAYMENTMETHOD_NEW_RECORD";
export const CREATE_PAYMENTMETHOD_NEW_RECORD_SUCCESS = "CREATE_PAYMENTMETHOD_NEW_RECORD_SUCCESS";
export const CREATE_PAYMENTMETHOD_NEW_RECORD_ERROR = "CREATE_PAYMENTMETHOD_NEW_RECORD_ERROR";

export const GET_PAYMENTMETHOD_NEW_RECORD = "GET_PAYMENTMETHOD_NEW_RECORD";
export const GET_PAYMENTMETHOD_NEW_RECORD_SUCCESS = "GET_PAYMENTMETHOD_NEW_RECORD_SUCCESS";
export const GET_PAYMENTMETHOD_NEW_RECORD_ERROR = "GET_PAYMENTMETHOD_NEW_RECORD_ERROR";

export const CREATE_PAYMENT_NEW_RECORD = "CREATE_PAYMENT_NEW_RECORD";
export const CREATE_PAYMENT_NEW_RECORD_SUCCESS = "CREATE_PAYMENT_NEW_RECORD_SUCCESS";
export const CREATE_PAYMENT_NEW_RECORD_ERROR = "CREATE_PAYMENT_NEW_RECORD_ERROR";

export const GET_PAYMENTMETHOD_RECORDS = "GET_PAYMENTMETHOD_RECORDS";
export const GET_PAYMENTMETHOD_RECORDS_SUCCESS = "GET_PAYMENTMETHOD_RECORDS_SUCCESS";
export const GET_PAYMENTMETHOD_RECORDS_ERROR = "GET_PAYMENTMETHOD_RECORDS_ERROR";

export const CREATE_VOCABULARY_NEW_RECORD = "CREATE_VOCABULARY_NEW_RECORD";
export const CREATE_VOCABULARY_NEW_RECORD_SUCCESS = "CREATE_VOCABULARY_NEW_RECORD_SUCCESS";
export const CREATE_VOCABULARY_NEW_RECORD_ERROR = "CREATE_VOCABULARY_NEW_RECORD_ERROR";

export const GET_VOCABULARY_NEW_RECORD = "GET_VOCABULARY_NEW_RECORD";
export const GET_VOCABULARY_NEW_RECORD_SUCCESS = "GET_VOCABULARY_NEW_RECORD_SUCCESS";
export const GET_VOCABULARY_NEW_RECORD_ERROR = "GET_VOCABULARY_NEW_RECORD_ERROR";

export const CREATE_PROCESS_NEW_RECORD = "CREATE_PROCESS_NEW_RECORD";
export const CREATE_PROCESS_NEW_RECORD_SUCCESS = "CREATE_PROCESS_NEW_RECORD_SUCCESS";
export const CREATE_PROCESS_NEW_RECORD_ERROR = "CREATE_PROCESS_NEW_RECORD_ERROR";

export const GET_PROCESS_NEW_RECORD = "GET_PROCESS_NEW_RECORD";
export const GET_PROCESS_NEW_RECORD_SUCCESS = "GET_PROCESS_NEW_RECORD_SUCCESS";
export const GET_PROCESS_NEW_RECORD_ERROR = "GET_PROCESS_NEW_RECORD_ERROR";

export const CREATE_COLLECTION_NEW_RECORD = "CREATE_COLLECTION_NEW_RECORD";
export const CREATE_COLLECTION_NEW_RECORD_SUCCESS = "CREATE_COLLECTION_NEW_RECORD_SUCCESS";
export const CREATE_COLLECTION_NEW_RECORD_ERROR = "CREATE_COLLECTION_NEW_RECORD_ERROR";

export const CREATE_TERM_NEW_RECORD = "CREATE_TERM_NEW_RECORD";
export const CREATE_TERM_NEW_RECORD_SUCCESS = "CREATE_TERM_NEW_RECORD_SUCCESS";
export const CREATE_TERM_NEW_RECORD_ERROR = "CREATE_TERM_NEW_RECORD_ERROR";

export const GET_TERM_NEW_RECORD = "GET_TERM_NEW_RECORD";
export const GET_TERM_NEW_RECORD_SUCCESS = "GET_TERM_NEW_RECORD_SUCCESS";
export const GET_TERM_NEW_RECORD_ERROR = "GET_TERM_NEW_RECORD_ERROR";

export const SET_RECORD_TYPE = "SET_RECORD_TYPE";
export const PANEL_NEW_RECORD_SHOW_HIDE_CLICK = "PANEL_NEW_RECORD_SHOW_HIDE_CLICK";
export const PANEL_NEW_RECORD_HIDE_CLICK = "PANEL_NEW_RECORD_HIDE_CLICK";
export const PANEL_NEW_RECORD_SHOW_CLICK = "PANEL_NEW_RECORD_SHOW_CLICK";
export const COMMENT_PANEL_SHOW_HIDE_CLICK = "COMMENT_PANEL_SHOW_HIDE_CLICK";
export const COMMENT_PANEL_SHOW_CLICK = "COMMENT_PANEL_SHOW_CLICK";
export const COMMENT_PANEL_HIDE_CLICK = "COMMENT_PANEL_HIDE_CLICK";
export const UPDATE_NEW_RECORD_STATE = "UPDATE_NEW_RECORD_STATE";

export const UPDATE_CATALOGITEM_NEW_RECORD = "UPDATE_CATALOGITEM_NEW_RECORD";
export const UPDATE_CATALOGITEM_NEW_RECORD_SUCCESS = "UPDATE_CATALOGITEM_NEW_RECORD_SUCCESS";
export const UPDATE_CATALOGITEM_NEW_RECORD_ERROR = "UPDATE_CATALOGITEM_NEW_RECORD_ERROR";

export const GET_CATALOGITEM_TERMS = "GET_CATALOGITEM_TERMS";
export const GET_CATALOGITEM_TERMS_SUCCESS = "GET_CATALOGITEM_TERMS_SUCCESS";
export const GET_CATALOGITEM_TERMS_ERROR = "GET_CATALOGITEM_TERMS_ERROR";

/* CONTACT_DETAILS */
export const GET_CONTACT = "GET_CONTACT";
export const GET_CONTACT_SUCCESS = "GET_CONTACT_SUCCESS";
export const GET_CONTACT_ERROR = "GET_CONTACT_ERROR";
export const GET_CONTACT_INFORMATION = "GET_CONTACT_INFORMATION";
export const GET_CONTACT_INFORMATION_SUCCESS = "GET_CONTACT_INFORMATION_SUCCESS";
export const GET_CONTACT_INFORMATION_ERROR = "GET_CONTACT_INFORMATION_ERROR";
export const CREATE_CONTACT_INFORMATION = "CREATE_CONTACT_INFORMATION";
export const CREATE_CONTACT_INFORMATION_SUCCESS = "CREATE_CONTACT_INFORMATION_SUCCESS";
export const CREATE_CONTACT_INFORMATION_ERROR = "CREATE_CONTACT_INFORMATION_ERROR";
export const UPDATE_CONTACT_INFORMATION = "UPDATE_CONTACT_INFORMATION";
export const UPDATE_CONTACT_INFORMATION_SUCCESS = "UPDATE_CONTACT_INFORMATION_SUCCESS";
export const UPDATE_CONTACT_INFORMATION_ERROR = "UPDATE_CONTACT_INFORMATION_ERROR";
export const TOGGLE_CREATE_CONTACT_INFORMATION_PANEL = "TOGGLE_CREATE_CONTACT_INFORMATION_PANEL";
export const TOGGLE_CREATE_CONTACT_INFORMATION_PANEL_SUCCESS = "TOGGLE_CREATE_CONTACT_INFORMATION_PANEL_SUCCESS";
export const GET_PRIMARY_CONTACT_METHODS = "GET_PRIMARY_CONTACT_METHODS";
export const GET_PRIMARY_CONTACT_METHODS_SUCCESS = "GET_PRIMARY_CONTACT_METHODS_SUCCESS";
export const GET_PRIMARY_CONTACT_METHODS_ERROR = "GET_PRIMARY_CONTACT_METHODS_ERROR";
export const GET_CONTACT_METHOD_TYPES = "GET_CONTACT_METHOD_TYPES";
export const GET_CONTACT_METHOD_TYPES_SUCCESS = "GET_CONTACT_METHOD_TYPES_SUCCESS";
export const GET_CONTACT_METHOD_TYPES_ERROR = "GET_CONTACT_METHOD_TYPES_ERROR";
export const GET_STATE_PROVINCES_FOR_SELECTED_COUNTRY = "GET_STATE_PROVINCES_FOR_SELECTED_COUNTRY";
export const CREATE_USER_ACCOUNT = "CREATE_USER_ACCOUNT";
export const CREATE_USER_ACCOUNT_SUCCESS = "CREATE_USER_ACCOUNT_SUCCESS";
export const CREATE_USER_ACCOUNT_ERROR = "CREATE_USER_ACCOUNT_ERROR";
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_ERROR = "CHANGE_USER_PASSWORD_ERROR";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const UPDATE_CONTACT_DETAILS_STATE = "UPDATE_CONTACT_DETAILS_STATE";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const UPDATE_CONTACT_ERROR = "UPDATE_CONTACT_ERROR";

export const GET_CONTACT_USERNAME_EXIST = "GET_CONTACT_USERNAME_EXIST";
export const GET_CONTACT_USERNAME_EXIST_SUCCESS = "GET_CONTACT_USERNAME_EXIST_SUCCESS";
export const GET_CONTACT_USERNAME_EXIST_ERROR = "GET_CONTACT_USERNAME_EXIST_ERROR";

export const GET_CONTACT_TERMS = "GET_CONTACT_TERMS";
export const GET_CONTACT_TERMS_SUCCESS = "GET_CONTACT_TERMS_SUCCESS";
export const GET_CONTACT_TERMS_ERROR = "GET_CONTACT_TERMS_ERROR";

export const GET_CONTACT_TERMS_SUFFIX = "GET_CONTACT_TERMS_SUFFIX";
export const GET_CONTACT_TERMS_SUFFIX_SUCCESS = "GET_CONTACT_TERMS_SUFFIX_SUCCESS";
export const GET_CONTACT_TERMS_SUFFIX_ERROR = "GET_CONTACT_TERMS_SUFFIX_ERROR";

/* PROCESS_DETAILS */
export const GET_PROCESS = "GET_PROCESS";
export const GET_PROCESS_SUCCESS = "GET_PROCESS_SUCCESS";
export const GET_PROCESS_ERROR = "GET_PROCESS_ERROR";
export const EXECUTE_PROCESS = "EXECUTE_PROCESS";
export const EXECUTE_PROCESS_SUCCESS = "EXECUTE_PROCESS_SUCCESS";
export const EXECUTE_PROCESS_ERROR = "EXECUTE_PROCESS_ERROR";
export const UPDATE_PROCESS_DETAILS_STATE = "UPDATE_PROCESS_DETAILS_STATE";

/* GET_TENANT */
export const GET_TENANT = "GET_TENANT";
export const GET_TENANT_SUCCESS = "GET_TENANT_SUCCESS";
export const GET_TENANT_ERROR = "GET_TENANT_ERROR";
export const DELETE_TENANT = "DELETE_TENANT";
export const DELETE_TENANT_SUCCESS = "DELETE_TENANT_SUCCESS";
export const DELETE_TENANT_ERROR = "DELETE_TENANT_ERROR";

/* VOCABULARY_DETAILS */
export const GET_VOCABULARY = "GET_VOCABULARY";
export const GET_VOCABULARY_SUCCESS = "GET_VOCABULARY_SUCCESS";
export const GET_VOCABULARY_ERROR = "GET_VOCABULARY_ERROR";

/* TERM_DETAILS */
export const GET_TERM = "GET_TERM";
export const GET_TERM_SUCCESS = "GET_TERM_SUCCESS";
export const GET_TERM_ERROR = "GET_TERM_ERROR";
export const DELETE_TERM = "DELETE_TERM";
export const DELETE_TERM_SUCCESS = "DELETE_TERM_SUCCESS";
export const DELETE_TERM_ERROR = "DELETE_TERM_ERROR";

/*Field Details*/
export const GET_Field_VOCABULARY_RECORDS = "GET_Field_VOCABULARY_RECORDS";
export const GET_Field_VOCABULARY_SUCCESS = "GET_Field_VOCABULARY_SUCCESS";
export const GET_Field_VOCABULARY_ERROR = "GET_Field_VOCABULARY_ERROR";

/* ACTIVITY_DETAILS */
export const GET_ACTIVITY = "GET_ACTIVITY";
export const GET_ACTIVITY_SUCCESS = "GET_ACTIVITY_SUCCESS";
export const GET_ACTIVITY_ERROR = "GET_ACTIVITY_ERROR";
export const DELETE_ACTIVITY = "DELETE_ACTIVITY";
export const DELETE_ACTIVITY_SUCCESS = "DELETE_ACTIVITY_SUCCESS";
export const DELETE_ACTIVITY_ERROR = "DELETE_ACTIVITY_ERROR";

/* COLLECTION_CREATE_UPDATE */

export const CREATE_COLLECTION_RECORD = "CREATE_COLLECTION_RECORD";
export const CREATE_COLLECTION_RECORD_SUCCESS = "CREATE_COLLECTION_RECORD_SUCCESS";
export const CREATE_COLLECTION_RECORD_ERROR = "CREATE_COLLECTION_RECORD_ERROR";
export const UPDATE_COLLECTION_RECORD_STATE = "UPDATE_COLLECTION_RECORD_STATE";

/* COLLECTION_DETAILS */
export const GET_COLLECTION = "GET_COLLECTION";
export const GET_COLLECTION_SUCCESS = "GET_COLLECTION_SUCCESS";
export const GET_COLLECTION_ERROR = "GET_COLLECTION_ERROR";

/* COLLECTION_ITEM_CREATE_UPDATE */
export const CREATE_COLLECTION_ITEM = "CREATE_COLLECTION_ITEM";
export const CREATE_COLLECTION_ITEM_SUCCESS = "CREATE_COLLECTION_ITEM_SUCCESS";
export const CREATE_COLLECTION_ITEM_ERROR = "CREATE_COLLECTION_ITEM_ERROR";
export const UPDATE_COLLECTION_ITEM_STATE = "UPDATE_COLLECTION_ITEM_STATE";
export const UPDATE_COLLECTION_ITEM = "UPDATE_COLLECTION_ITEM";
export const UPDATE_COLLECTION_ITEM_SUCCESS = "UPDATE_COLLECTION_ITEM_SUCCESS";
export const UPDATE_COLLECTION_ITEM_ERROR = "UPDATE_COLLECTION_ITEM_ERROR";
export const CLEAR_COLLECTION_ITEM = "CLEAR_COLLECTION_ITEM";

/* PARTICIPANT_CREATE_UPDATE */
export const CREATE_PARTICIPANT = "CREATE_PARTICIPANT";
export const CREATE_PARTICIPANT_SUCCESS = "CREATE_PARTICIPANT_SUCCESS";
export const CREATE_PARTICIPANT_ERROR = "CREATE_PARTICIPANT_ERROR";
export const UPDATE_PARTICIPANT_STATE = "UPDATE_PARTICIPANT_STATE";
export const GET_PARTICIPANT_COLLECTION = "GET_PARTICIPANT_COLLECTION";
export const GET_PARTICIPANT_COLLECTION_SUCCESS = "GET_PARTICIPANT_COLLECTION_SUCCESS";
export const GET_PARTICIPANT_COLLECTION_ERROR = "GET_PARTICIPANT_COLLECTION_ERROR";

/* COLLECTION__ITEM_DETAILS */
export const GET_COLLECTION_ITEM = "GET_COLLECTION_ITEM";
export const GET_COLLECTION_ITEM_SUCCESS = "GET_COLLECTION_ITEM_SUCCESS";
export const GET_COLLECTION_ITEM_ERROR = "GET_COLLECTION_ITEM_ERROR";

/* NEW_CONTACT_CARD */
export const PANEL_NEW_CONTACT_CARD_SHOW_HIDE_CLICK = "PANEL_NEW_CONTACT_CARD_SHOW_HIDE_CLICK";

/* GET_LIST */
export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_ERROR = "GET_SETTINGS_ERROR";

/* GET_PAGE_DATA */
export const GET_PAGE_DATA = "GET_PAGE_DATA";
export const GET_PAGE_DATA_SUCCESS = "GET_PAGE_DATA_SUCCESS";
export const GET_PAGE_DATA_ERROR = "GET_PAGE_DATA_ERROR";
export const GET_COLLECTION_OPTIONS = "GET_COLLECTION_OPTIONS";
export const GET_COLLECTION_OPTIONS_SUCCESS = "GET_COLLECTION_OPTIONS_SUCCESS";
export const GET_COLLECTION_OPTIONS_ERROR = "GET_COLLECTION_OPTIONS_ERROR";

/* SIGNUP_CREATE */
export const CREATE_SIGNUP = "CREATE_SIGNUP";
export const CREATE_SIGNUP_SUCCESS = "CREATE_SIGNUP_SUCCESS";
export const CREATE_SIGNUP_ERROR = "CREATE_SIGNUP_ERROR";
export const CREATE_SIGNUP_CLEAR_DATA = "CREATE_SIGNUP_CLEAR_DATA";

/* ARTICLE_CREATE */
export const CREATE_ARTICLE = "CREATE_ARTICLE";
export const CREATE_ARTICLE_SUCCESS = "CREATE_ARTICLE_SUCCESS";
export const CREATE_ARTICLE_ERROR = "CREATE_ARTICLE_ERROR";
export const CREATE_ARTICLE_CLEAR_DATA = "CREATE_ARTICLE_CLEAR_DATA";

/* NEWS_ITEMS */
export const GET_NEWS_ITEMS = "GET_NEWS_ITEMS";
export const GET_NEWS_ITEMS_SUCCESS = "GET_NEWS_ITEMS_SUCCESS";
export const GET_NEWS_ITEMS_ERROR = "GET_NEWS_ITEMS_ERROR";

export const GET_POST_ITEMS = "GET_POST_ITEMS";
export const GET_POST_ITEMS_SUCCESS = "GET_POST_ITEMS_SUCCESS";
export const GET_POST_ITEMS_ERROR = "GET_POST_ITEMS_ERROR";

export const CREATE_POST_NEW_RECORD = "CREATE_POST_NEW_RECORD";
export const CREATE_POST_NEW_RECORD_SUCCESS = "CREATE_POST_NEW_RECORD_SUCCESS";
export const CREATE_POST_NEW_RECORD_ERROR = "CREATE_POST_NEW_RECORD_ERROR";

export const UPDATE_NEWS_ITEM = "UPDATE_NEWS_ITEM";
export const UPDATE_NEWS_ITEM_SUCCESS = "UPDATE_NEWS_ITEM_SUCCESS";
export const UPDATE_NEWS_ITEM_ERROR = "UPDATE_NEWS_ITEM_ERROR";
export const UPDATE_NEWS_FEED = "UPDATE_NEWS_FEED";
export const GET_LIKED_POSTS_BY_CURRENT_USER = "GET_LIKED_POSTS_BY_CURRENT_USER";
export const GET_LIKED_POSTS_BY_CURRENT_USER_SUCCESS = "GET_LIKED_POSTS_BY_CURRENT_USER_SUCCESS";
export const GET_LIKED_POSTS_BY_CURRENT_USER_ERROR = "GET_LIKED_POSTS_BY_CURRENT_USER_ERROR";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_ERROR = "ADD_COMMENT_ERROR";
export const ADD_COMMENT_ITEM = "ADD_COMMENT_ITEM";
export const GET_COMMENTS = "GET_COMMENTS";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_ERROR = "GET_COMMENTS_ERROR";
export const GET_POST_LIKES = "GET_POST_LIKES";
export const GET_POST_LIKES_SUCCESS = "GET_POST_LIKES_SUCCESS";
export const GET_POST_LIKES_ERROR = "GET_POST_LIKES_ERROR";

/* ARTICLE_DETAILS */
export const GET_ARTICLE = "GET_ARTICLE";
export const GET_ARTICLE_SUCCESS = "GET_ARTICLE_SUCCESS";
export const GET_ARTICLE_ERROR = "GET_ARTICLE_ERROR";
export const ADD_REPLY = "ADD_REPLY";
export const ADD_REPLY_SUCCESS = "ADD_REPLY_SUCCESS";
export const ADD_REPLY_ERROR = "ADD_REPLY_ERROR";
export const ARTICLE_DETAILS_CLEAR_DATA = "ARTICLE_DETAILS_CLEAR_DATA";


/* PAYMENT_DETAILS */
export const GET_PAYMENT = "GET_PAYMENT";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_ERROR = "GET_PAYMENT_ERROR";

/* ORDER_DETAILS */
export const GET_ORDER = "GET_ORDER";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_ERROR = "GET_ORDER_ERROR";

/* EXTRA */
export const EDIT_BUTTON_PRESSED = "EDIT_BUTTON_PRESSED";
export const CREATE_BUTTON_PRESSED = "CREATE_BUTTON_PRESSED";

/* UPDATE_TENANT */
export const UPDATE_TENANT = "UPDATE_TENANT";
export const UPDATE_TENANT_SUCCESS = "UPDATE_TENANT_SUCCESS";
export const UPDATE_TENANT_ERROR = "UPDATE_TENANT_ERROR";
export const UPDATE_TENANT_EDIT_STATE = "UPDATE_TENANT_EDIT_STATE";

export * from "./panel/actions";
export * from "./auth/actions";
